import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {PROMOS_QUERY_KEY} from "../queryKeys";
import {ReachPromo, ReachPromoPayload} from "./types";

const createPromo = async (payload: ReachPromoPayload): Promise<ReachPromo> => {
  const response = await axiosReachInstance.post<ReachPromo, AxiosResponse<ReachPromo>, ReachPromoPayload>(
    "/promos",
    payload
  );
  return response.data;
};

export const useCreatePromo = (
  options?: BaseMutationOptions<ReachPromo, ReachPromoPayload>
): BaseUseMutationResult<ReachPromo, ReachPromoPayload> => {
  return useBaseMutation<ReachPromo, ReachPromoPayload>(createPromo, {
    ...options,
    prefixKeysToInvalidate: () => [[PROMOS_QUERY_KEY]],
  });
};
